import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'

// 处理重定向的问题
const routerPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

// 每次用户请求都需要创建一个新的router实例
// 创建createRouter工厂函数
export default function createRouter() {
  // 创建router实例
  const router = new Router({
    mode: 'history',
    fallback: false,
    routes: [
      // 首页（预加载）
      {
        path: '/',
        name: 'home',
        component: () => import('../views/index.vue')
      },
      // 竞赛模块
      {
        path: '/competition',
        name: 'saiti',
        // 修改后（添加webpackChunkName）
        component: () => import('../views/saiti/index.vue')
      },
      {
        path: '/competitionInfo/:id?/:inviteId?',
        name: 'saitiinfo',
        component: () => import('../views/saiti/info.vue')
      },
      {
        path: '/competitionInfo/s/:id/i/:inviteId',
        name: 'competitionInfo',
        component: () => import('../views/saiti/info.vue')
      },
      {
        path: '/zone',
        name: 'zone',
        component: () => import('../views/zone/index.vue')
      },
      {
        path: '/news',
        name: 'news',
        component: () => import('../views/news/index.vue')
      },
      {
        path: '/more/certificate', // 证书查询 - 重定向到验证页面
        name: 'certificate',
        redirect: '/more/certificate/verify'
      },
      {
        path: '/more/certificate/verify', // 证书真伪验证
        name: 'certificateVerify',
        component: () => import('../views/more/certificate/verify.vue')
      },
      {
        path: '/more/organize', // 我要办赛
        name: 'organize',
        component: () => import('../views/more/organize/index.vue')
      },
      {
        path: '/newsinfo',
        name: 'newsinfo',
        component: () => import('../views/news/info.vue')
      },
      {
        path: '/article/:id',
        name: 'singlepage',
        component: () => import('../views/article/index.vue')
      },
      {
        path: '/search',
        name: 'search',
        component: () => import('../views/search/index.vue')
      },
      // 个人中心
      {
        path: '/myrecord',
        name: 'myrecord',
        component: () => import('../views/person/record.vue'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/myexamine',
        name: 'myexamine',
        component: () => import('../views/person/examine.vue'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/myapply',
        name: 'myapply',
        component: () => import('../views/person/apply.vue'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/mymessage',
        name: 'mymessage',
        component: () => import('../views/person/message.vue'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/myinvitation',
        name: 'myinvitation',
        component: () => import('../views/person/MyInvitation.vue'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/mypersonal',
        name: 'mypersonal',
        component: () => import('../views/person/PersonalInformation.vue'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/mycollect',
        name: 'mycollect',
        component: () => import('../views/person/collect.vue'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/mybrowse',
        name: 'mybrowse',
        component: () => import('../views/person/browse.vue'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/competitionhosting',
        name: 'competitionhosting',
        component: () => import('../views/person/CompetitionHostingHistory.vue'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/previewinfo',
        name: 'previewinfo',
        component: () => import('../views/saiti/previewinfo.vue')
      },
      {
        path: '/document',
        name: 'document',
        component: () => import('../views/article/CompetitionSiteArticleList.vue')
      },

      {
        path: '/login',
        component: () => import('../views/auth/login.vue'),
        props: route => ({ from: route.query.from })
      },

      {
        path: '/callback',
        component: () => import('../views/auth/callback.vue'),
        props: route => ({
          code: route.query.code,
          from: route.query.from
        })
      },

      {
        path: '*',
        name: 'nofound',
        component: () => import('../views/404/index.vue')
      }
    ]
  })

  router.afterEach((to) => {
    if (typeof window !== 'undefined' && window._oafs) {
      const useInfo = JSON.parse(Cookies.get('atom_user') || '{}') || {}
      window._oafs.setDefault({
        pageId: document.title,
        userId: useInfo ? useInfo.id : undefined,
        extra: {
          path: to.path
        }
      })
      window._oafs.pv()
    }
  })

  return router
}
